//#region src/order_skip_reason.ts
var OrderSkipReason = /* @__PURE__ */ function(OrderSkipReason) {
	OrderSkipReason["NonSyncOps"] = "skip-non-sync-ops";
	OrderSkipReason["ProdI9n"] = "skip-prod-i9n";
	OrderSkipReason["OfflineDemoMode"] = "offline-demo-mode";
	OrderSkipReason["UnsentOrder"] = "skip-unsent-order";
	OrderSkipReason["UnvalidatedOrder"] = "skip-unvalidated-order";
	OrderSkipReason["UsesOnPremApi"] = "skip-uses-on-prem-api";
	return OrderSkipReason;
}(OrderSkipReason || {});
//#endregion
export { OrderSkipReason };

//# sourceMappingURL=order_skip_reason.js.map